<template>
  <div class="layout_container">
    <header-section />
    <top-section />
    <main-section />
    <footer-section />
  </div>
</template>

<script>
import HeaderSection from './components/header'
import TopSection from './components/topSection'
import MainSection from './components/main'
import FooterSection from './components/footer'

export default {
  name: 'HomePage',
  components: {
    HeaderSection,
    TopSection,
    MainSection,
    FooterSection,
  },
}
</script>

<style>
html {
  scroll-behavior: smooth; /* 启用平滑滚动 */
}
</style>
